'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _button = require('@hixme-ui/button');

var _button2 = _interopRequireDefault(_button);

var _closeButton = require('@hixme-ui/close-button');

var _closeButton2 = _interopRequireDefault(_closeButton);

var _title = require('@hixme-ui/title');

var _title2 = _interopRequireDefault(_title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MrModal = function MrModal(_ref) {
  var backgroundColor = _ref.backgroundColor,
      children = _ref.children,
      hideCloseButton = _ref.hideCloseButton,
      isOpen = _ref.isOpen,
      handleClose = _ref.handleClose,
      style = _ref.style,
      title = _ref.title,
      zIndex = _ref.zIndex,
      transparent = _ref.transparent,
      contentCenter = _ref.contentCenter,
      contentEnd = _ref.contentEnd,
      contentPadding = _ref.contentPadding,
      middle = _ref.middle,
      bottom = _ref.bottom,
      small = _ref.small,
      medium = _ref.medium,
      large = _ref.large,
      cancelHandler = _ref.cancelHandler,
      cancelLabel = _ref.cancelLabel,
      cancelProcessing = _ref.cancelProcessing,
      cancelSubmittingText = _ref.cancelSubmittingText,
      confirmHandler = _ref.confirmHandler,
      confirmLabel = _ref.confirmLabel,
      confirmProcessing = _ref.confirmProcessing,
      confirmSubmittingText = _ref.confirmSubmittingText,
      dialog = _ref.dialog,
      errorDialog = _ref.errorDialog,
      restProps = (0, _objectWithoutProperties3.default)(_ref, ['backgroundColor', 'children', 'hideCloseButton', 'isOpen', 'handleClose', 'style', 'title', 'zIndex', 'transparent', 'contentCenter', 'contentEnd', 'contentPadding', 'middle', 'bottom', 'small', 'medium', 'large', 'cancelHandler', 'cancelLabel', 'cancelProcessing', 'cancelSubmittingText', 'confirmHandler', 'confirmLabel', 'confirmProcessing', 'confirmSubmittingText', 'dialog', 'errorDialog']);

  var getButtonGrid = function getButtonGrid() {
    if (small) {
      return {
        xs: 12,
        sm: 6
      };
    } else if (medium) {
      return {
        xs: 12,
        sm: 6,
        md: 4
      };
    } else if (large) {
      return {
        xs: 12,
        sm: 6,
        md: 4,
        lg: 2
      };
    }
    return {
      xs: 12,
      sm: 6,
      md: 4,
      lg: 2
    };
  };

  var getMrModalStyle = function getMrModalStyle() {
    var nonFullScreenStyle = {
      overlay: {
        zIndex: zIndex,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(40, 48, 54, 0.8)'
      },
      content: {
        zIndex: zIndex + 1,
        maxHeight: '85vh',
        position: 'unset',
        margin: '30px',
        backgroundColor: backgroundColor || '#fff',
        border: '0',
        borderRadius: '6px',
        top: 'unset',
        right: 'unset',
        bottom: 'unset',
        left: 'unset'
      }
    };

    if (small) {
      return (0, _extends3.default)({}, nonFullScreenStyle, {
        content: (0, _extends3.default)({}, nonFullScreenStyle.content, {
          width: '568px'
        })
      });
    } else if (medium) {
      return (0, _extends3.default)({}, nonFullScreenStyle, {
        content: (0, _extends3.default)({}, nonFullScreenStyle.content, {
          width: '800px'
        })
      });
    } else if (large) {
      return (0, _extends3.default)({}, nonFullScreenStyle, {
        content: (0, _extends3.default)({}, nonFullScreenStyle.content, {
          width: '1024px'
        })
      });
    }
    return {
      overlay: {
        zIndex: zIndex,
        backgroundColor: transparent ? 'transparent' : 'none'
      },
      content: {
        zIndex: zIndex + 1,
        height: '100%',
        width: '100%',
        border: '0',
        borderRadius: '0',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
        backgroundColor: transparent ? 'rgba(40, 48, 54, 0.8)' : backgroundColor || '#fff'
      }
    };
  };

  var getAlign = function getAlign() {
    if (middle) return { middle: 'xs' };else if (bottom) return { bottom: 'xs' };
    return { top: 'xs' };
  };

  var getContentAlign = function getContentAlign() {
    if (contentCenter) return { center: 'xs' };else if (contentEnd) return { end: 'xs' };
    return { start: 'xs' };
  };

  return _react2.default.createElement(
    _reactModal2.default,
    (0, _extends3.default)({
      style: style || getMrModalStyle(),
      isOpen: isOpen,
      onRequestClose: cancelHandler || handleClose,
      ariaHideApp: true,
      shouldCloseOnEsc: true
    }, restProps),
    _react2.default.createElement(
      _reactFlexboxGrid.Grid,
      { fluid: true, style: { height: '100%', padding: '0', position: 'relative' } },
      !hideCloseButton && _react2.default.createElement(
        _reactFlexboxGrid.Row,
        {
          end: 'xs',
          style: {
            margin: '0',
            width: '100%',
            position: 'absolute',
            top: '0',
            right: '0'
          }
        },
        _react2.default.createElement(_closeButton2.default, { onClick: cancelHandler || handleClose })
      ),
      _react2.default.createElement(
        _reactFlexboxGrid.Row,
        (0, _extends3.default)({ center: 'xs' }, getAlign(), { style: { height: '100%' } }),
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 12, style: { marginTop: middle || bottom ? '-50px' : '0' } },
          _react2.default.createElement(
            'div',
            { style: { padding: contentPadding || '0' } },
            title && _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { center: 'xs', style: { marginTop: '20px' } },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: true },
                _react2.default.createElement(
                  _title2.default,
                  { small: true },
                  title
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              getContentAlign(),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12 },
                children
              )
            ),
            dialog && _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { center: 'xs', style: { marginTop: '20px' } },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                (0, _extends3.default)({}, getButtonGrid(), { style: { marginBottom: '10px' } }),
                _react2.default.createElement(
                  _button2.default,
                  {
                    secondary: true,
                    block: true,
                    onClick: cancelHandler || handleClose,
                    submitting: cancelProcessing,
                    submittingText: cancelSubmittingText
                  },
                  cancelLabel
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                getButtonGrid(),
                _react2.default.createElement(
                  _button2.default,
                  {
                    primary: true,
                    block: true,
                    onClick: confirmHandler,
                    submitting: confirmProcessing,
                    submittingText: confirmSubmittingText
                  },
                  confirmLabel
                )
              )
            ),
            errorDialog && _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { center: 'xs', style: { marginTop: '20px' } },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                (0, _extends3.default)({}, getButtonGrid(), { style: { marginBottom: '10px' } }),
                _react2.default.createElement(
                  _button2.default,
                  {
                    secondary: true,
                    block: true,
                    onClick: cancelHandler || handleClose,
                    submitting: cancelProcessing,
                    submittingText: cancelSubmittingText
                  },
                  cancelLabel
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                getButtonGrid(),
                _react2.default.createElement(
                  _button2.default,
                  {
                    red: true,
                    block: true,
                    onClick: confirmHandler,
                    submitting: confirmProcessing,
                    submittingText: confirmSubmittingText
                  },
                  confirmLabel
                )
              )
            )
          )
        )
      )
    )
  );
};

// hixme-ui


MrModal.propTypes = {
  backgroundColor: _propTypes2.default.string,
  children: _propTypes2.default.node,
  handleClose: _propTypes2.default.func.isRequired,
  hideCloseButton: _propTypes2.default.bool,
  isOpen: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  title: _propTypes2.default.string,
  transparent: _propTypes2.default.bool,
  zIndex: _propTypes2.default.number,

  // Content align
  contentCenter: _propTypes2.default.bool,
  contentEnd: _propTypes2.default.bool,

  // Content spacing
  contentPadding: _propTypes2.default.string,

  // Vertical Align
  middle: _propTypes2.default.bool,
  bottom: _propTypes2.default.bool,

  // Sizes
  small: _propTypes2.default.bool,
  medium: _propTypes2.default.bool,
  large: _propTypes2.default.bool,

  // Dialog presets
  cancelHandler: _propTypes2.default.func,
  cancelLabel: _propTypes2.default.string,
  cancelProcessing: _propTypes2.default.bool,
  cancelSubmittingText: _propTypes2.default.string,
  confirmHandler: _propTypes2.default.func,
  confirmLabel: _propTypes2.default.string,
  confirmProcessing: _propTypes2.default.bool,
  confirmSubmittingText: _propTypes2.default.string,
  dialog: _propTypes2.default.bool,
  errorDialog: _propTypes2.default.bool
};

MrModal.defaultProps = {
  backgroundColor: null,
  children: _react2.default.createElement('div', null),
  hideCloseButton: false,
  isOpen: false,
  // isProcessing: false,
  style: undefined,
  title: '',
  transparent: false,
  zIndex: 1001,

  // Content align
  contentCenter: false,
  contentEnd: false,

  // Content spacing
  contentPadding: null,

  // Vertical Align
  middle: false,
  bottom: false,

  // Sizes
  small: false,
  medium: false,
  large: false,

  // Dialog presets
  cancelHandler: undefined,
  cancelLabel: 'Cancel',
  cancelProcessing: false,
  cancelSubmittingText: _button2.default.defaultProps.submittingText || 'Cancelling...',
  confirmHandler: function confirmHandler() {
    return console.log('Confirm click');
  }, // eslint-disable-line
  confirmLabel: 'Ok',
  confirmProcessing: false,
  confirmSubmittingText: _button2.default.defaultProps.submittingText || 'Submitting...',
  dialog: false,
  errorDialog: false
};

MrModal.displayName = 'MrModal';

exports.default = MrModal;
//# sourceMappingURL=MrModal.js.map


//////////////////
// WEBPACK FOOTER
// ../modal/lib/MrModal.js
// module id = 722
// module chunks = 0